import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classnames from 'classnames';
import { palette } from '../../design-system/colors';

const useStyles = makeStyles(() => ({
    speechBubbleStyles: {
        padding: '16px',
        backgroundColor: 'white',
        border: `2px solid ${palette.lightroom.heavyMetalLightUltra}`,
        boxShadow: 'none',

        marginBottom: 'unset !important',

        // overriding global style that's giving label extra margin
        '& .MuiFormControlLabel-label': {
            marginLeft: 'unset !important',
        },
    },
    rightBubble: {
        borderRadius: '24px 24px 0px 24px',
        backgroundColor: '#F7F7F7',
    },
    leftBubble: {
        borderRadius: '24px 24px 24px 0px',
    },
    isAnswer: {
        cursor: 'default',
        '&:hover': {
            boxShadow: 'none',
        },
    },
    isUserCorrect: {
        backgroundColor: palette.lightroom.aspargusLightHigh,
        borderColor: palette.evergreen.aspargus,
        borderWidth: '2px',
    },
    isIncorrect: {
        backgroundColor: palette.lightroom.redLightHigh,
        borderColor: palette.vibrant.red,
        borderWidth: '2px',
        '& .MuiCheckbox-root': {
            color: palette.vibrant.red,
        },
    },
    isSelected: {
        borderWidth: '2px',
        borderColor: palette.graphite.heavyMetal,
    },
    checkboxStyles: {
        '& .MuiFormControlLabel-label': {
            fontSize: '13px',
            fontFamily: 'Nunito Sans, sans-serif',
            color: palette.graphite.heavyMetal,
            fontWeight: 700,
        },
    },
    checkboxIsUserCorrect: {
        '& .MuiFormControlLabel-label': {
            color: palette.evergreen.aspargus,
        },
        '& .MuiCheckbox-root': {
            color: palette.evergreen.aspargus,
        },
    },
    checkboxIsIncorrect: {
        '& .MuiFormControlLabel-label': {
            color: palette.vibrant.red,
        },
        '& .MuiCheckbox-root': {
            color: palette.vibrant.red,
        },
    },
    unStyledLabel: {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        padding: 0,
        marginBottom: 'unset',

        '&:hover': {
            boxShadow: 'none',
        },
    },

    unStyledCheckbox: {
        margin: '0 !important',
        padding: '2px !important',
    },
}));

/** Checkbox input without border or shade, and displays answer with styled checkmark, not the Cancel/Correct icons
 * Example usage: Used in the 'select_none' option in Conversation questions */
export function UnStyledCheckboxInput({
    label,
    groupValue,
    value,
    lighter,
    isUserCorrect,
    isIncorrect,
    isAnswer,
    ...props
}) {
    const classes = useStyles();
    const isChecked = //This checkbox should be checked if...
        (groupValue || []).includes(value) || //...its value is one of the ones currently selected
        (isAnswer && (isIncorrect || isUserCorrect)); //...or it's displaying a selected answer

    return (
        <FormControlLabel
            className={classnames(
                classes.checkboxStyles,
                classes.unStyledLabel,
                {
                    [classes.checkboxIsIncorrect]: isIncorrect,
                    [classes.checkboxIsUserCorrect]: isUserCorrect,
                    [classes.isAnswer]: isAnswer,
                }
            )}
            control={
                <Checkbox
                    className={classnames(classes.unStyledCheckbox, {
                        [classes.isAnswer]: isAnswer,
                    })}
                    checked={isChecked}
                    color="primary"
                    {...props}
                />
            }
            label={label}
        />
    );
}

export function SpeechBubbleInput({
    label,
    groupValue,
    value,
    side,
    isUserCorrect,
    isIncorrect,
    isAnswer,
    onChange,
    ...props
}) {
    const classes = useStyles();

    return (
        <FormControlLabel
            className={classnames(classes.speechBubbleStyles, {
                [classes.isSelected]: (groupValue || []).includes(value),
                [classes.leftBubble]: side === 'left',
                [classes.rightBubble]: side === 'right',
                [classes.isAnswer]: isAnswer,

                [classes.isUserCorrect]: isUserCorrect,
                [classes.isIncorrect]: isIncorrect,
            })}
            control={
                <Checkbox
                    checked={(groupValue || []).includes(value)}
                    onChange={onChange}
                    hidden={true}
                />
            }
            label={label}
            {...props}
        />
    );
}
